import { apiClient } from '../lib/api/client'
import { Client } from '../types'
import { IRepository } from './types'

export interface StaysReservationReport {
  id: string
  stays_id: string
  stays_code: string
  type: string
  currency: string
  check_in_date: string
  check_out_date: string
  guest_total_count: number
  night_count: number
  creation_date: string
  price_per_night: number
  reserve_total: number
  listing_invoice_total: number
  extra_services_total: number
  listing_id: string
  base_amount_forwarding: number
  sell_price_corrected: number
  company_commission: number
  buy_price: number
  total_cleaning_fee: number
  total_forward_fee: number
  total_forward_fee_after: number
  total_forward_fee_all: number
  client: Client
  has_review: boolean
  partner_name: string
  owner_fee: { val: number; desc: string }[]
  owner_fee_after: { val: number; desc: string }[]
  documents: any[]
  fee: { val: number; desc: string }[]
  partner_code: string
  created_at: string
  updated_at: string
}

export interface FinancialReport {
  owner_id: string
  owner_name: string
  total_revenue: number
  adr: number
  available_days_to_sell: number
  company_commission: number
  total_fowarding_fee: number
  total_cleaning_fee: number
  total_maintenance_fee: number
  room_nights_sold: number
  occupancy_rate: number
  properties: {
    id: string
    code: string
    title: string
    maintenance_fees: {
      id: string
      repair_date: string
      cost: number
      description: string
    }[]
    owner: {
      id: string
      name: string
    }
  }[]
  property_id?: string
  property_title?: string
  properties_count: number
  properties_reservations: {
    [key: string]: StaysReservationReport[]
  }
}

export interface GetFinancialReportParams {
  startDate: string
  endDate: string
  ownerId?: string
}

export class ReportRepository
  implements IRepository<FinancialReport, any, any>
{
  async getAll({
    startDate,
    endDate,
    ownerId,
  }: GetFinancialReportParams): Promise<FinancialReport[]> {
    const params = new URLSearchParams({
      startDate,
      endDate,
    })

    if (ownerId) {
      params.append('ownerId', ownerId)
    }

    const response = await apiClient.invoke<FinancialReport[]>(
      `financial-report?${params.toString()}`,
      {
        method: 'GET',
      }
    )

    return response.sort((a: any, b: any) => b.owner_name - a.owner_name)
  }

  async getOne({
    startDate,
    endDate,
    ownerId,
  }: GetFinancialReportParams): Promise<FinancialReport> {
    const params = new URLSearchParams({
      startDate,
      endDate,
    })

    if (ownerId) {
      params.append('ownerId', ownerId)
    }

    return apiClient.invoke<FinancialReport>(
      `financial-report?${params.toString()}`,
      {
        method: 'GET',
      }
    )
  }

  // The following methods are not needed for this repository, but are required by the IRepository interface.
  async getById(_id: string | number): Promise<FinancialReport | null> {
    throw new Error('Method not implemented.')
  }
  async create(_data: any): Promise<FinancialReport> {
    throw new Error('Method not implemented.')
  }
  async update(_id: string | number, _data: any): Promise<FinancialReport> {
    throw new Error('Method not implemented.')
  }
  async delete(_id: string | number): Promise<void> {
    throw new Error('Method not implemented.')
  }
  async restore(_id: string | number): Promise<void> {
    throw new Error('Method not implemented.')
  }
}
